import { Component, type ReactNode } from 'react'
import { AlertTriangle, RefreshCw } from 'lucide-react'

interface Props { children: ReactNode }
interface State { hasError: boolean; error: Error | null }

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
          <div className="card max-w-sm w-full text-center space-y-4">
            <div className="h-14 w-14 rounded-2xl bg-red-100 flex items-center justify-center mx-auto">
              <AlertTriangle className="h-7 w-7 text-red-500" />
            </div>
            <div>
              <h2 className="font-bold text-gray-900 text-lg">Something went wrong</h2>
              <p className="text-sm text-gray-500 mt-1">
                {this.state.error?.message ?? 'An unexpected error occurred.'}
              </p>
            </div>
            <button
              className="btn-primary w-full"
              onClick={() => {
                this.setState({ hasError: false, error: null })
                window.location.href = '/dashboard'
              }}
            >
              <RefreshCw className="h-4 w-4" /> Reload
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
